import PlayIcon from "@/assets/colorable/play.svg?react";
import ContentApprovalStatusChip from "@/components/Campaign/management/activeTab/ContentApprovalStatusChip";
import clsxm from "@/lib/clsxm";
import {shouldMuteVideosAtom} from "@/store/jotaiAtoms";
import type {TMediaType} from "@/store/types";
import {useSetAtom} from "jotai";
import {useRef, useState, type FC} from "react";
import {useHoverDirty} from "react-use";

type TReportingContentCardData = {
  image?: string;
  media_file?: string | null;
  media_type?: TMediaType;
  media_url?: string | File | null;
  status?: "PUBLISHED" | "REJECTED";
  thumbnail_url?: string | File | null;
};

const ReportingContentCard: FC<{data: TReportingContentCardData}> = ({data}) => {
  const {image, media_file, media_type, media_url, status = "PUBLISHED", thumbnail_url} = data;
  const contentRef = useRef<HTMLDivElement>(null!);
  const isHovering = useHoverDirty(contentRef);
  const setShouldMuteVideos = useSetAtom(shouldMuteVideosAtom);
  const [isVideoReady, setIsVideoReady] = useState(false);
  const isVideo = media_type === "VIDEO";

  return (
    <div ref={contentRef} className="relative">
      {(!isHovering || !isVideo) && status === "REJECTED" && (
        <ContentApprovalStatusChip className="absolute top-2 left-2 z-10" status="REJECTED" />
      )}
      <img
        draggable={false}
        className="h-64 w-44 rounded-lg"
        src={isVideo ? (image ?? thumbnail_url?.toString()) : (image ?? media_url?.toString())}
        alt="Influencer Content"
      />
      {isVideo && !isHovering && (
        <div className="border-neutral-white-dark bg-neutral-white-dark/20 absolute top-1/2 left-1/2 flex size-20 -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full border">
          <PlayIcon className="size-8 pl-1.5 text-white" />
        </div>
      )}
      {isVideo && isHovering && (
        <video
          autoPlay
          className={clsxm(
            "absolute inset-0 block h-64 w-44 rounded-lg object-cover opacity-0 transition-opacity duration-150",
            isVideoReady && "opacity-100",
          )}
          controls
          controlsList="nodownload"
          draggable={false}
          loop
          onCanPlay={() => setIsVideoReady(true)}
          playsInline
          muted
          src={media_file ?? media_url?.toString()}
          onVolumeChange={e => setShouldMuteVideos(e.currentTarget.muted || e.currentTarget.volume === 0)}
        />
      )}
    </div>
  );
};

export default ReportingContentCard;
